/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Noaccount1Inputs */

const zh_auth_noaccount1 = /** @type {(inputs: Auth_Noaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有账户？`)
};

const en_auth_noaccount1 = /** @type {(inputs: Auth_Noaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

const es_auth_noaccount1 = /** @type {(inputs: Auth_Noaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No tienes una cuenta?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Auth_Noaccount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_noaccount1 = /** @type {((inputs?: Auth_Noaccount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Noaccount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_noaccount1(inputs)
	if (locale === "en") return en_auth_noaccount1(inputs)
	return es_auth_noaccount1(inputs)
});
export { auth_noaccount1 as "auth_noAccount" }